import { ResponseCatalog } from 'Models'
import { axiosDS } from '@pp/axios'
import { RegionsModel } from 'Pages/referenceBooks'
import { urls } from 'Constants/Urls'
import { OutLinks } from 'Constants/OutLinks'
import { dadataApiKey, DadataIpAddress } from 'Pages/orders'

export const regionByIpApi = {
	getRegions: async () => {
		const res = await axiosDS().get<ResponseCatalog<RegionsModel>>(urls.orders.regions)
		return res.data
	},

	getIp: async () => {
		const res = await axiosDS({ isExternal: true }).get<string>(OutLinks.getIp)
		return res.data
	},
	getDadataAddressByIp: async (ip: string) => {
		const urlData = OutLinks.daData.replace(':ip', ip)
		const responseConfig = {
			headers: {
				Authorization: `Token ${dadataApiKey}`,
			},
		}
		const res = await axiosDS({ isExternal: true }).get<DadataIpAddress>(urlData, responseConfig)
		return res.data
	},
}
